// extracted by mini-css-extract-plugin
export default {"GetInTouch":"GetInTouch_GetInTouch__2W6k-","GetInTouchInner":"GetInTouch_GetInTouchInner__7lQXn"};